import { ReactNode, useEffect } from 'react'
import { useTranslation } from '@hooks/useTranslation'

interface RTLProviderProps {
  children: ReactNode
}

export function RTLProvider({ children }: RTLProviderProps) {
  const { isRTL } = useTranslation()

  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.documentElement.lang = document.documentElement.lang || 'en-US'
  }, [isRTL])

  return <>{children}</>
}
